export default function AdminRevenue({ ctx }) {
  const { stats } = ctx;
  const data = stats.revenue_30d || [];
  const max = Math.max(1, ...data.map((d) => d.revenue));
  const total30 = stats.revenue_30d_total || 0;
  const fmtDay = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("default", { month: "short", day: "numeric" });
  const cards = [
    { l: "Total revenue (all time)", v: `$${(stats.total_revenue || 0).toFixed(0)}` },
    { l: "Revenue · last 30 days", v: `$${total30.toFixed(0)}` },
    { l: "Class bookings", v: stats.total_class_bookings || 0 },
    { l: "Tutorial sales", v: stats.total_tutorial_sales || 0 },
    { l: "Creator bookings", v: stats.total_studio_bookings || 0 },
  ];
  return (
    <div className="mt-6 space-y-4" data-testid="admin-revenue">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.l} className="p-6 rounded-2xl bg-white border border-stone-200">
            <p className="text-xs tracking-[0.2em] uppercase text-stone-500">{c.l}</p>
            <p className="font-serif font-black text-4xl text-[#121212] mt-2">{c.v}</p>
          </div>
        ))}
      </div>
      <div data-testid="revenue-chart" className="p-6 rounded-2xl bg-white border border-stone-200">
        <p className="text-xs tracking-[0.2em] uppercase text-stone-500">Daily paid revenue · last 30 days</p>
        {data.length === 0 || max === 1 ? (
          <p className="text-stone-500 text-sm mt-6">No revenue in the last 30 days yet — paid bookings and orders will chart here automatically.</p>
        ) : (
          <>
            <div className="mt-6 flex items-end gap-[3px] h-48">
              {data.map((d) => (
                <div key={d.date} className="group relative flex-1 flex flex-col justify-end h-full" title={`${fmtDay(d.date)} · $${d.revenue.toFixed(2)}`}>
                  <div className="w-full bg-[#C6FF33] hover:bg-[#121212] transition-colors rounded-sm" style={{ height: `${Math.max(2, (d.revenue / max) * 100)}%` }} />
                </div>
              ))}
            </div>
            <div className="flex justify-between mt-2 text-[10px] text-stone-400">
              <span>{fmtDay(data[0].date)}</span>
              <span>{fmtDay(data[data.length - 1].date)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
